import { post } from '@/utils/payrequst'
/**
 * 支付宝打款审核
 */
export function get_withdraw_list(data) {
  return post('get_withdraw_list', data)
}
// 拒绝审核提现信息
export function reject_withdraw_info(data) {
  return post('reject_withdraw_info', data)
}
//获取提现的批次列表
export function get_withdraw_batch_list(data) {
  return post('get_withdraw_batch_list', data)
}
//批次下单接口,(传入需要支付的提现id,生成付款链接)
export function fund_batch_create(data) {
  return post('fund_batch_create', data)
}
//电子回单申请(完整)
export function ereceipt_data_apply(data) {
  return post('ereceipt_data_apply', data)
}